// Set up your root reducer here...
 import { combineReducers } from 'redux';
 import srtStats from './srtStatsReducer';
 import streamList from './streamListReducer'
 import streamConfig from './streamConfigReducer'
 import notification from './notificationReducer'
 import sysConfig from './sysConfigReducer'
 import tsReport from './tsReportReducer'
import { routerReducer } from 'react-router-redux';

const rootReducer = combineReducers({
  srtStats,
  tsReport,
  streamList,
  streamConfig,
  notification,
  routing: routerReducer,
  sysConfig
});

 export default rootReducer;
